import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

import { MLoggerService } from '@mercadona/core/logger';
import { MPlatformService } from '@mercadona/core/platform';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  accessDenied = false;
  isPortrait: boolean = false;

  options: AnimationOptions = {
    path: ' /assets/animation/force_horizontal.json'
  };

  constructor(
    private router: Router,
    private mPlatformService: MPlatformService,
    private cdRef: ChangeDetectorRef,
    private mLoggerService: MLoggerService
  ) {}

  ngOnInit() {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.checkCallback();
      }
    });
  }
  ngAfterViewInit(): void {
    const deviceType = this.mPlatformService.getDeviceInfo().deviceType;

    /**
     * Check the device, if it is a tablet or mobile phone, check its orientation.
     */
    if (deviceType === 'tablet' || /mobile|phone|smartphone/i.test(deviceType)) {
      this.handleOrientationChange();
      this.cdRef.detectChanges();
    }
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event: Event): void {
    const deviceType = this.mPlatformService.getDeviceInfo().deviceType;

    if (deviceType === 'tablet' || /mobile|phone|smartphone/i.test(deviceType)) {
      /**
       * Check if the browser supports the visualViewport API. This API is more reliable,
       * especially on mobile devices, for getting accurate dimensions of the viewport.
       */
      if ('visualViewport' in window) {
        /**
         * The call is wrapped in a setTimeout to avoid possible synchronisation problems.
         */
        setTimeout(() => {
          this.handleOrientationChange();
        }, 100);
      } else {
        this.handleOrientationChange();
      }
    }
  }

  private handleOrientationChange(): void {
    const visualViewport = window.visualViewport;
    if (visualViewport) {
      const { width, height } = visualViewport;
      this.isPortrait = width <= height;
    } else {
      this.isPortrait = window.outerWidth <= window.outerHeight;
    }
  }

  private checkCallback() {
    const pathName = window.location.pathname;
    if (this.hasAccessDenied() && (/callback/.test(pathName) || pathName === '/')) {
      this.accessDenied = true;
    }
  }

  private hasAccessDenied() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('error') && urlParams.get('error') === 'access_denied';
  }

  animationCreated(animationItem: AnimationItem): void {
    this.mLoggerService.log(animationItem);
  }
}
